import React, { useContext, useEffect } from 'react'
import styled from 'styled-components'
import { stripUnit } from 'polished'

import { H4, fontSizes } from 'styles/typography'
import * as spacing from 'styles/spacing'
import { media } from 'styles/media'

import Heading from 'components/buy/Engraving/Heading'
import SummaryItem from 'components/buy/Engraving/SummaryItem'
import { EngravingContext } from 'components/buy/Engraving/EngravingContext'

const Subheading = styled(H4)`
  margin-bottom: ${spacing.small};

  ${media.medium`
    margin-bottom: ${stripUnit(spacing.small) * 1.5 + 'px'};
  `};

  ${media.large`
    margin-bottom: ${spacing.medium};
  `};
`

const Disclaimer = styled.p`
  font-size: ${fontSizes.tiny};
  margin-top: ${stripUnit(spacing.medium) * 1.25 + 'px'};

  ${media.medium`
    margin-top: ${spacing.large};
  `};
`

const Summary = () => {
  const { engraving, currentView, setCurrentView } = useContext(EngravingContext)

  useEffect(() => {
    setCurrentView({ ...currentView, item: 'summary', step: 'initialstep' })
  }, [])

  return (
    <>
      <Heading title="Engraving Summary" />
      <Subheading>Items</Subheading>
      <div>
        {Object.keys(engraving).map((key, idx) => {
          if (key === 'front' || key === 'back') return <SummaryItem key={idx} item={key} />
        })}
      </div>
      <Disclaimer>
        Ships in 5 to 10 business days. As each ePod is laser printed individually to meet your customization
        guidelines, the design may vary slightly from what's pictured. Please note, personalized items are made to order
        and cannot be exchanged or returned.
      </Disclaimer>
    </>
  )
}

export default Summary
